"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAllProjects;
const axios_1 = __importDefault(require("axios"));
const helpers_1 = require("../helpers");
const env_1 = require("../../../utils/env");
const either_1 = require("../../../types/either");
const helpers_2 = require("../helpers");
function getAllProjects(_a) {
  return __awaiter(this, arguments, void 0, function (_ref) {
    let {
      flashId,
      token,
      sortBy,
      sortOrder,
      schemaVersion,
      exclude,
      page,
      pageSize,
      lastEvaluatedKey,
      lastEvaluatedKeyV1
    } = _ref;
    return function* () {
      try {
        const baseUrl = (0, env_1.getCrudCoreBaseUrl)();
        if (baseUrl.isLeft()) {
          return (0, either_1.left)(baseUrl.value);
        }
        const url = new URL('api/projects', baseUrl.value);
        url.searchParams.set('flashId', flashId);
        if (sortBy) {
          url.searchParams.set('sortBy', sortBy);
        }
        if (sortOrder) {
          url.searchParams.set('sortOrder', sortOrder);
        }
        if (schemaVersion) {
          url.searchParams.set('schemaVersion', schemaVersion);
        }
        if (exclude) {
          url.searchParams.set('exclude', exclude);
        }
        if (page) {
          url.searchParams.set('page', String(page !== null && page !== void 0 ? page : ''));
        }
        if (pageSize) {
          url.searchParams.set('pageSize', String(pageSize !== null && pageSize !== void 0 ? pageSize : ''));
        }
        if (lastEvaluatedKey) {
          url.searchParams.set('lastEvaluatedKey', encodeURIComponent(JSON.stringify(lastEvaluatedKey)));
        }
        if (lastEvaluatedKeyV1) {
          url.searchParams.set('lastEvaluatedKeyV1', encodeURIComponent(JSON.stringify(lastEvaluatedKeyV1)));
        }
        const response = yield axios_1.default.get(url.toString(), (0, helpers_1.axiosConfig)(token));
        return (0, either_1.right)(response.data);
      } catch (error) {
        return (0, either_1.left)((0, helpers_2.getAxiosError)(error));
      }
    }();
  });
}